import { render, staticRenderFns } from "./ModalChangeWorkspace.vue?vue&type=template&id=7f87a774&"
import script from "./ModalChangeWorkspace.vue?vue&type=script&lang=js&"
export * from "./ModalChangeWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangeWorkspace.vue?vue&type=style&index=0&id=7f87a774&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports